import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FlexModule } from '@angular/flex-layout/flex';
import { ResendSignedConsentDialogData, ResendSignedConsentDialogResult } from '@portal-workspace/grow-shared-library';

@Component({
  templateUrl: './resend-signed-consent.dialog.html',
  styleUrls: ['./resend-signed-consent.dialog.scss'],
  standalone: true,
  imports: [FlexModule, MatButtonModule, MatDialogModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule],
})
export class ResendSignedConsentDialog {

  reasonControl: FormControl<string>;
  title: string;
  warning: string;
  submitLabel: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ResendSignedConsentDialogData,
    private dialogRef: MatDialogRef<ResendSignedConsentDialog, ResendSignedConsentDialogResult>,
    formBuilder: FormBuilder,
  ) {
    this.reasonControl = formBuilder.nonNullable.control('', [
      Validators.required,
      Validators.maxLength(500),
      control => (typeof control.value === 'string' && control.value.trim() ? null : { required: true }),
    ]);
    const name = data.name?.trim() || 'This individual';
    this.title = data.title ?? 'Resend privacy consent';
    this.warning = data.warning
      ?? `${name} has already signed their privacy consent form. Resending will supersede the signed form, mark the signed document as Rejected, and email a new form for them to sign. Privacy consent will show as incomplete until the new form is signed.`;
    this.submitLabel = data.submitLabel ?? 'Resend';
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSubmit() {
    if (this.reasonControl.invalid) {
      return;
    }
    const result: ResendSignedConsentDialogResult = {
      readyForSubmission: true,
      reason: this.reasonControl.value.trim(),
    };
    this.dialogRef.close(result);
  }
}
